import { render, staticRenderFns } from "./subjectEdit.vue?vue&type=template&id=0a182596&scoped=true"
import script from "./subjectEdit.vue?vue&type=script&lang=js"
export * from "./subjectEdit.vue?vue&type=script&lang=js"
import style0 from "./subjectEdit.vue?vue&type=style&index=0&id=0a182596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a182596",
  null
  
)

export default component.exports